module.exports = __webpack_public_path__ + "static/img/img19.cd6730c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/help/img19.png
// module id = lfq0
// module chunks = 1